import React, { useState, useEffect, useRef, useContext } from "react";
import axios from "axios";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Button from "components/CustomButtons/Button.js";
import ImageUpload from "components/CustomUpload/ImageUpload.js";
import FloatInput from "components/Input/FloatInput.js";
import TextInput from "components/Input/TextInput.js";
import IntInput from "components/Input/IntInput.js";
import DateInput from "components/Input/DateInput.js";
import CustomSelect from "components/Input/CustomSelect.js";
import AutocompleteInput from "components/Input/AutocompleteInput.js";
import AutocompleteTagsInput from "components/Input/AutocompleteTagsInput.js";
import LocalizationAutocomplete from "components/LocalizationAutocomplete/LocalizationAutocomplete";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import UserService from "services/UserService";
import { region, batiment } from "variables/patrimoine.js";
import { getSite, getProfilePicture, getFiles, postFileUpload } from "services/ConfigServices";
import { makeStyles } from "@mui/styles";
import { NotificationManager } from 'react-notifications';
import Chip from "@mui/material/Chip";
import { periodData } from "variables/lists/patrimoine";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: '#fff',
    display: "flex",
    fontFamily: '"Source Sans Pro",sans-serif',

  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
  },
  textInput: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  tab: {
    paddingLeft: "0rem",
    marginLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
  },
  input: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0rem 0rem",
    color: "#000000",
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  inputImage: {
    display: "flex",
    flexDirection: "column",
    margin: "0rem 0rem 0rem",
    color: "#000000",
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  inputTitle: {
    margin: "0.2rem 0rem 0.05rem 0.5rem",
    color: "rgba(0, 0, 0, 0.54)",
    fontFamily: '"Source Sans Pro",sans-serif',
    fontSize: "12px",
  },
  select: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0.5rem",
  },
  switch: {
    marginLeft: "0.5rem",
  },
}));


function Occupation(props) {
  const permis = JSON.parse(localStorage.getItem('permission')) || [];
  const realestateupdate = permis.includes("realestate_update");
  const [occupancycountperiode, setOccupancycountperiode] = useState("");
  const [occupancycountvalue, setOccupancycountvalue] = useState("");
  const [maximalcapacity, setMaximalcapacity] = useState("");
  const [averageoccupancy, setAverageoccupancy] = useState("");
  const [occupancytimeperiode, setOccupancytimeperiode] = useState("");
  const [occupancytimevalue, setOccupancytimevalue] = useState("");
  const [occupancycomments, setOccupancycomments] = useState("");
  const [mondayschedulestart, setMondayschedulestart] = useState("");
  const [tuesdayschedulestart, setTuesdayschedulestart] = useState("");
  const [wednesdayschedulestart, setWednesdayschedulestart] = useState("");
  const [thursdayschedulestart, setThursdayschedulestart] = useState("");
  const [fridayschedulestart, setFridayschedulestart] = useState("");
  const [saturdayschedulestart, setSaturdayschedulestart] = useState("");
  const [sundayschedulestart, setSundayschedulestart] = useState("");
  const [mondayscheduleend, setMondayscheduleend] = useState("");
  const [tuesdayscheduleend, setTuesdayscheduleend] = useState("");
  const [wednesdayscheduleend, setWednesdayscheduleend] = useState("");
  const [thursdayscheduleend, setThursdayscheduleend] = useState("");
  const [fridayscheduleend, setFridayscheduleend] = useState("");
  const [saturdayscheduleend, setSaturdayscheduleend] = useState("");
  const [sundayscheduleend, setSundayscheduleend] = useState("");
  const [comments, setComments] = useState("");
  const [description, setDescription] = useState("");


  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;

  const handleOccupancycountperiodeChange = (event) => { setOccupancycountperiode(event.target.value); };
  const handleOccupancycountvalueChange = (event) => { setOccupancycountvalue(event.target.value); };
  const handleMaximalcapacityChange = (event) => { setMaximalcapacity(event.target.value); };
  const handleAverageoccupancyChange = (event) => { setAverageoccupancy(event.target.value); };
  const handleOccupancytimeperiodeChange = (event) => { setOccupancytimeperiode(event.target.value); };
  const handleOccupancytimevalueChange = (event) => { setOccupancytimevalue(event.target.value); };
  const handleMondayschedulestartChange = (event) => { setMondayschedulestart(event.target.value); };
  const handleTuesdayschedulestartChange = (event) => { setTuesdayschedulestart(event.target.value); };
  const handleWednesdayschedulestartChange = (event) => { setWednesdayschedulestart(event.target.value); };
  const handleThursdayschedulestartChange = (event) => { setThursdayschedulestart(event.target.value); };
  const handleFridayschedulestartChange = (event) => { setFridayschedulestart(event.target.value); };
  const handleSaturdayschedulestartChange = (event) => { setSaturdayschedulestart(event.target.value); };
  const handleSundayschedulestartChange = (event) => { setSundayschedulestart(event.target.value); };
  const handleMondayscheduleendChange = (event) => { setMondayscheduleend(event.target.value); };
  const handleTuesdayscheduleendChange = (event) => { setTuesdayscheduleend(event.target.value); };
  const handleWednesdayscheduleendChange = (event) => { setWednesdayscheduleend(event.target.value); };
  const handleThursdayscheduleendChange = (event) => { setThursdayscheduleend(event.target.value); };
  const handleFridayscheduleendChange = (event) => { setFridayscheduleend(event.target.value); };
  const handleSaturdayscheduleendChange = (event) => { setSaturdayscheduleend(event.target.value); };
  const handleSundayscheduleendChange = (event) => { setSundayscheduleend(event.target.value); };
  const handleCommentsChange = (event) => { setComments(event.target.value); };
  const handleDescriptionChange = (event) => { setDescription(event.target.value); };


  useEffect(() => {
    axios
      .get(
        getSite(chartIdGroup, "parameters.occupation"),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        setOccupancycountperiode(res.data.detail.parameters?.occupation?.occupancycountperiode);
        setOccupancycountvalue(res.data.detail.parameters?.occupation?.occupancycountvalue);
        setMaximalcapacity(res.data.detail.parameters?.occupation?.maximalcapacity);
        setAverageoccupancy(res.data.detail.parameters?.occupation?.averageoccupancy);
        setOccupancytimeperiode(res.data.detail.parameters?.occupation?.occupancytimeperiode);
        setOccupancytimevalue(res.data.detail.parameters?.occupation?.occupancytimevalue);
        setOccupancycomments(res.data.detail.parameters?.occupation?.occupancycomments);
        setMondayschedulestart(res.data.detail.parameters?.occupation?.mondayschedulestart);
        setTuesdayschedulestart(res.data.detail.parameters?.occupation?.tuesdayschedulestart);
        setWednesdayschedulestart(res.data.detail.parameters?.occupation?.wednesdayschedulestart);
        setThursdayschedulestart(res.data.detail.parameters?.occupation?.thursdayschedulestart);
        setFridayschedulestart(res.data.detail.parameters?.occupation?.fridayschedulestart);
        setSaturdayschedulestart(res.data.detail.parameters?.occupation?.saturdayschedulestart);
        setSundayschedulestart(res.data.detail.parameters?.occupation?.sundayschedulestart);
        setMondayscheduleend(res.data.detail.parameters?.occupation?.mondayscheduleend);
        setTuesdayscheduleend(res.data.detail.parameters?.occupation?.tuesdayscheduleend);
        setWednesdayscheduleend(res.data.detail.parameters?.occupation?.wednesdayscheduleend);
        setThursdayscheduleend(res.data.detail.parameters?.occupation?.thursdayscheduleend);
        setFridayscheduleend(res.data.detail.parameters?.occupation?.fridayscheduleend);
        setSaturdayscheduleend(res.data.detail.parameters?.occupation?.saturdayscheduleend);
        setSundayscheduleend(res.data.detail.parameters?.occupation?.sundayscheduleend);
        setComments(res.data.detail.parameters?.occupation?.comments);
        setDescription(res.data.detail.parameters?.occupation?.description);

      })
      .catch(() => { });
  }, []);

  const handleEdit = () => {
    axios
      .put(
        getSite(chartIdGroup, "parameters.occupation"),
        {
          occupancycountperiode,
          occupancycountvalue,
          maximalcapacity,
          averageoccupancy,
          occupancytimeperiode,
          occupancytimevalue,
          occupancycomments,
          mondayschedulestart,
          tuesdayschedulestart,
          wednesdayschedulestart,
          thursdayschedulestart,
          fridayschedulestart,
          saturdayschedulestart,
          sundayschedulestart,
          mondayscheduleend,
          tuesdayscheduleend,
          wednesdayscheduleend,
          thursdayscheduleend,
          fridayscheduleend,
          saturdayscheduleend,
          sundayscheduleend,
          comments,
          description,

        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success("Modifications enregistrées");
        }
        else {
          NotificationManager.error("Une erreur est survenue");
        }
      })
      .catch(() => {
        NotificationManager.error("Une erreur est survenue");
      });
  };



  const classes = useStyles();
  return (
    <div style={{ marginTop: "-15px" }}>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <div>
            <CustomSelect
              inputTitle={batiment.parameters.occupation.occupancycountperiode}
              selectValue={occupancycountperiode}
              handleSelectValueChange={handleOccupancycountperiodeChange}
              data={periodData}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <IntInput
              inputTitle={batiment.parameters.occupation.occupancycountvalue}
              intInput={occupancycountvalue}
              handleIntInputChange={handleOccupancycountvalueChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <IntInput
              inputTitle={batiment.parameters.occupation.maximalcapacity}
              intInput={maximalcapacity}
              handleIntInputChange={handleMaximalcapacityChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <FloatInput
              inputTitle={batiment.parameters.occupation.averageoccupancy}
              floatInput={averageoccupancy}
              handleFloatInputChange={handleAverageoccupancyChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <CustomSelect
              inputTitle={batiment.parameters.occupation.occupancytimeperiode}
              selectValue={occupancytimeperiode}
              handleSelectValueChange={handleOccupancytimeperiodeChange}
              data={periodData}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <IntInput
              inputTitle={batiment.parameters.occupation.occupancytimevalue}
              intInput={occupancytimevalue}
              handleIntInputChange={handleOccupancytimevalueChange}
              disabled={!realestateupdate}
            />
          </div>
          <GridContainer>
            <GridItem xs={6} sm={6} md={6}>
              <div>
                <DateInput
                  specialType={"time"}
                  inputTitle={batiment.parameters.occupation.mondayschedulestart}
                  dateInput={mondayschedulestart}
                  handleDateInputChange={handleMondayschedulestartChange}
                  disabled={!realestateupdate}
                />
              </div>
            </GridItem>
            <GridItem xs={6} sm={6} md={6}>
              <div>
                <DateInput
                  specialType={"time"}
                  inputTitle={batiment.parameters.occupation.mondayscheduleend}
                  dateInput={mondayscheduleend}
                  handleDateInputChange={handleMondayscheduleendChange}
                  disabled={!realestateupdate}
                />
              </div>
            </GridItem>
            <GridItem xs={6} sm={6} md={6}>
              <div>
                <DateInput
                  specialType={"time"}
                  inputTitle={batiment.parameters.occupation.tuesdayschedulestart}
                  dateInput={tuesdayschedulestart}
                  handleDateInputChange={handleTuesdayschedulestartChange}
                  disabled={!realestateupdate}
                />
              </div>
            </GridItem>
            <GridItem xs={6} sm={6} md={6}>
              <div>
                <DateInput
                  specialType={"time"}
                  inputTitle={batiment.parameters.occupation.tuesdayscheduleend}
                  dateInput={tuesdayscheduleend}
                  handleDateInputChange={handleTuesdayscheduleendChange}
                  disabled={!realestateupdate}
                />
              </div>
            </GridItem>
            <GridItem xs={6} sm={6} md={6}>
              <div>
                <DateInput
                  specialType={"time"}
                  inputTitle={batiment.parameters.occupation.wednesdayschedulestart}
                  dateInput={wednesdayschedulestart}
                  handleDateInputChange={handleWednesdayschedulestartChange}
                  disabled={!realestateupdate}
                />
              </div>
            </GridItem>
            <GridItem xs={6} sm={6} md={6}>
              <div>
                <DateInput
                  specialType={"time"}
                  inputTitle={batiment.parameters.occupation.wednesdayscheduleend}
                  dateInput={wednesdayscheduleend}
                  handleDateInputChange={handleWednesdayscheduleendChange}
                  disabled={!realestateupdate}
                />
              </div>
            </GridItem>
            <GridItem xs={6} sm={6} md={6}>
              <div>
                <DateInput
                  specialType={"time"}
                  inputTitle={batiment.parameters.occupation.thursdayschedulestart}
                  dateInput={thursdayschedulestart}
                  handleDateInputChange={handleThursdayschedulestartChange}
                  disabled={!realestateupdate}
                />
              </div>
            </GridItem>
            <GridItem xs={6} sm={6} md={6}>
              <div>
                <DateInput
                  specialType={"time"}
                  inputTitle={batiment.parameters.occupation.thursdayscheduleend}
                  dateInput={thursdayscheduleend}
                  handleDateInputChange={handleThursdayscheduleendChange}
                  disabled={!realestateupdate}
                />
              </div>
            </GridItem>
            <GridItem xs={6} sm={6} md={6}>
              <div>
                <DateInput
                  specialType={"time"}
                  inputTitle={batiment.parameters.occupation.fridayschedulestart}
                  dateInput={fridayschedulestart}
                  handleDateInputChange={handleFridayschedulestartChange}
                  disabled={!realestateupdate}
                />
              </div>
            </GridItem>
            <GridItem xs={6} sm={6} md={6}>
              <div>
                <DateInput
                  specialType={"time"}
                  inputTitle={batiment.parameters.occupation.fridayscheduleend}
                  dateInput={fridayscheduleend}
                  handleDateInputChange={handleFridayscheduleendChange}
                  disabled={!realestateupdate}
                />
              </div>
            </GridItem>
            <GridItem xs={6} sm={6} md={6}>
              <div>
                <DateInput
                  specialType={"time"}
                  inputTitle={batiment.parameters.occupation.saturdayschedulestart}
                  dateInput={saturdayschedulestart}
                  handleDateInputChange={handleSaturdayschedulestartChange}
                  disabled={!realestateupdate}
                />
              </div>
            </GridItem>
            <GridItem xs={6} sm={6} md={6}>
              <div>
                <DateInput
                  specialType={"time"}
                  inputTitle={batiment.parameters.occupation.saturdayscheduleend}
                  dateInput={saturdayscheduleend}
                  handleDateInputChange={handleSaturdayscheduleendChange}
                  disabled={!realestateupdate}
                />
              </div>
            </GridItem>
            <GridItem xs={6} sm={6} md={6}>
              <div>
                <DateInput
                  specialType={"time"}
                  inputTitle={batiment.parameters.occupation.sundayschedulestart}
                  dateInput={sundayschedulestart}
                  handleDateInputChange={handleSundayschedulestartChange}
                  disabled={!realestateupdate}
                />
              </div>
            </GridItem>
            <GridItem xs={6} sm={6} md={6}>
              <div>
                <DateInput
                  specialType={"time"}
                  inputTitle={batiment.parameters.occupation.sundayscheduleend}
                  dateInput={sundayscheduleend}
                  handleDateInputChange={handleSundayscheduleendChange}
                  disabled={!realestateupdate}
                />
              </div>
            </GridItem>
          </GridContainer>
          <div>
            <TextInput
              inputTitle={batiment.parameters.occupation.comments}
              textInput={comments}
              handleTextInputChange={handleCommentsChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <TextInput
              inputTitle={batiment.parameters.occupation.description}
              textInput={description}
              handleTextInputChange={handleDescriptionChange}
              disabled={!realestateupdate}
            />
          </div>
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              marginTop: "1rem",
              marginLeft: "auto",
              marginRight: "0.2rem",
            }}
          >
            {realestateupdate ? <Button
              style={{
                color: "#FFFFFF",
                backgroundColor: "#91C73C",
                fontWeight: "normal",
                fontWeight: "bold",
                height: "40px",
                fontSize: "0.75rem",
                padding: "5px 15px",
                marginRight: "5px",
                marginBottom: "0px",
                marginTop: "0px",
                fontFamily: '"Source Sans Pro",sans-serif',
              }}
              onClick={() => {
                handleEdit();
              }}
            >
              Enregistrer
            </Button> : <></>}
          </div>
        </GridItem>
      </GridContainer>

    </div>
  );
}

function Ratio(props) {
  const permis = JSON.parse(localStorage.getItem('permission')) || [];
  const realestateupdate = permis.includes("realestate_update");
  const [energyshon, setEnergyshon] = useState("");
  const [costshon, setCostshon] = useState("");
  const [energyhabitant, setEnergyhabitant] = useState("");

  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;

  const handleEnergyshonChange = (event) => { setEnergyshon(event.target.value); };
  const handleCostshonChange = (event) => { setCostshon(event.target.value); };
  const handleEnergyhabitantChange = (event) => { setEnergyhabitant(event.target.value); };

  const classes = useStyles();

  useEffect(() => {
    axios
      .get(
        getSite(chartIdGroup, "parameters.ratio"),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        setEnergyshon(res.data.detail.parameters?.ratio?.energyshon);
        setCostshon(res.data.detail.parameters?.ratio?.costshon);
        setEnergyhabitant(res.data.detail.parameters?.ratio?.energyhabitant);
      })
      .catch(() => { });
  }, []);

  const handleEdit = () => {
    axios
      .put(
        getSite(chartIdGroup, "parameters.ratio"),
        {
          energyshon,
          costshon,
          energyhabitant,
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success("Modifications enregistrées");
        }
        else {
          NotificationManager.error("Une erreur est survenue");
        }
      })
      .catch(() => {
        NotificationManager.error("Une erreur est survenue");
      });
  };

  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <div>
            <FloatInput
              inputTitle={region.parameters.ratio.energyshon}
              floatInput={energyshon}
              handleFloatInputChange={handleEnergyshonChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <FloatInput
              inputTitle={region.parameters.ratio.costshon}
              floatInput={costshon}
              handleFloatInputChange={handleCostshonChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <FloatInput
              inputTitle={region.parameters.ratio.energyhabitant}
              floatInput={energyhabitant}
              handleFloatInputChange={handleEnergyhabitantChange}
              disabled={!realestateupdate}
            />
          </div>

        </GridItem>

        <GridItem xs={12} sm={12} md={12}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              marginTop: "1rem",
              marginLeft: "auto",
              marginRight: "0.2rem",
            }}
          >
            {realestateupdate ? <Button
              style={{
                color: "#FFFFFF",
                backgroundColor: "#91C73C",
                fontWeight: "normal",
                fontWeight: "bold",
                height: "40px",
                fontSize: "0.75rem",
                padding: "5px 15px",
                marginRight: "5px",
                marginBottom: "0px",
                marginTop: "0px",
                fontFamily: '"Source Sans Pro",sans-serif',
              }}
              onClick={() => {
                handleEdit();
              }}
            >
              Enregistrer
            </Button> : <></>}
          </div>
        </GridItem>
      </GridContainer>
    </div>
  );
}

function Property(props) {
  const permis = JSON.parse(localStorage.getItem('permission')) || [];
  const realestateupdate = permis.includes("realestate_update");
  const [performancegrade, setPerformancegrade] = useState("");
  const [performancecomment, setPerformancecomment] = useState("");
  const [dilapidationgrade, setDilapidationgrade] = useState("");
  const [dilapidationcomment, setDilapidationcomment] = useState("");
  const [otherproperties, setOtherproperties] = useState([]);

  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;

  const handlePerformancegradeChange = (event) => { setPerformancegrade(event.target.value); };
  const handlePerformancecommentChange = (event) => { setPerformancecomment(event.target.value); };
  const handleDilapidationgradeChange = (event) => { setDilapidationgrade(event.target.value); };
  const handleDilapidationcommentChange = (event) => { setDilapidationcomment(event.target.value); };
  const handleOtherpropertiesChange = (newvalue) => { setOtherproperties(newvalue); };

  useEffect(() => {
    axios
      .get(
        getSite(chartIdGroup, "parameters.properties"),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        setPerformancegrade(res.data.detail.parameters?.properties?.performancegrade);
        setPerformancecomment(res.data.detail.parameters?.properties?.performancecomment);
        setDilapidationgrade(res.data.detail.parameters?.properties?.dilapidationgrade);
        setDilapidationcomment(res.data.detail.parameters?.properties?.dilapidationcomment);
        setOtherproperties(res.data.detail.parameters?.properties?.otherproperties || []);
      })
      .catch(() => { });
  }, []);

  const handleEdit = () => {
    axios
      .put(
        getSite(chartIdGroup, "parameters.properties"),
        {
          performancegrade,
          performancecomment,
          dilapidationgrade,
          dilapidationcomment,
          otherproperties,
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success("Modifications enregistrées");
        }
        else {
          NotificationManager.error("Une erreur est survenue");
        }
      })
      .catch(() => {
        NotificationManager.error("Une erreur est survenue");
      });
  };

  const autocompleteOptions = [];
  const classes = useStyles();
  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <div>
            <TextInput
              inputTitle={region.parameters.properties.performancegrade}
              textInput={performancegrade}
              handleTextInputChange={handlePerformancegradeChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <TextInput
              inputTitle={region.parameters.properties.performancecomment}
              textInput={performancecomment}
              handleTextInputChange={handlePerformancecommentChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <TextInput
              inputTitle={region.parameters.properties.dilapidationgrade}
              textInput={dilapidationgrade}
              handleTextInputChange={handleDilapidationgradeChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <TextInput
              inputTitle={region.parameters.properties.dilapidationcomment}
              textInput={dilapidationcomment}
              handleTextInputChange={handleDilapidationcommentChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <AutocompleteTagsInput
              inputTitle={region.parameters.properties.otherproperties}
              list={autocompleteOptions}
              selected={otherproperties}
              handleChange={handleOtherpropertiesChange}
              disabled={!realestateupdate}
            />
          </div>
        </GridItem>

        <GridItem xs={12} sm={12} md={12}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              marginTop: "1rem",
              marginLeft: "auto",
              marginRight: "0.2rem",
            }}
          >
            {realestateupdate ? <Button
              style={{
                color: "#FFFFFF",
                backgroundColor: "#91C73C",
                fontWeight: "normal",
                fontWeight: "bold",
                height: "40px",
                fontSize: "0.75rem",
                padding: "5px 15px",
                marginRight: "5px",
                marginBottom: "0px",
                marginTop: "0px",
                fontFamily: '"Source Sans Pro",sans-serif',
              }}
              onClick={() => {
                handleEdit();
              }}
            >
              Enregistrer
            </Button> : <></>}
          </div>
        </GridItem>
      </GridContainer>
    </div>
  );
}

function Other(props) {
  const permis = JSON.parse(localStorage.getItem('permission')) || [];
  const realestateupdate = permis.includes("realestate_update");
  const [associatedfiles, setAssociatedfiles] = useState("");
  const [comments, setComments] = useState("");
  const [description, setDescription] = useState("");

  const [gedList, setGedList] = useState([
    { fileName: String, fileId: Number },
  ]);

  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;

  const handleAssociatedfilesChange = (newValue) => {
    let newArray = [];
    for (let i = 0; i < newValue.length; i++) {
      newArray.push(newValue[i]);
    }
    setAssociatedfiles(newArray);
  };
  const handleCommentsChange = (event) => { setComments(event.target.value); };
  const handleDescriptionChange = (event) => { setDescription(event.target.value); };

  const selectedGed = () => {
    let gedCardId = [];
    let getGedNames;
    if (associatedfiles !== undefined) {
      for (let i = 0; i < associatedfiles.length; i++) {
        gedCardId.push(associatedfiles[i].fileId);
      }
      getGedNames = gedList.filter((gedList) =>
        gedCardId.includes(gedList.fileId)
      );
    }
    return getGedNames;
  };

  useEffect(() => {
    axios
      .get(
        getFiles(chartIdGroup),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        setGedList(res.data.collection);
      });
  }, []);

  useEffect(() => {
    axios
      .get(
        getSite(chartIdGroup, "parameters.other"),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        setAssociatedfiles(res.data.detail.parameters?.other?.associatedfiles || []);
        setComments(res.data.detail.parameters?.other?.comments);
        setDescription(res.data.detail.parameters?.other?.description);
      })
      .catch(() => { });
  }, []);

  const handleEdit = () => {
    axios
      .put(
        getSite(chartIdGroup, "parameters.other"),
        {
          associatedfiles,
          comments,
          description,
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success("Modifications enregistrées");
        }
        else {
          NotificationManager.error("Une erreur est survenue");
        }
      })
      .catch(() => {
        NotificationManager.error("Une erreur est survenue");
      });
  };

  const classes = useStyles();
  return (
    <div style={{ marginTop: "-15px" }}>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <div>
            <AutocompleteInput
              disabled={!realestateupdate}
              inputTitle={region.parameters.other.associatedfiles}
              selected={selectedGed()}
              list={gedList}
              handleChange={(_, newValue) =>
                handleAssociatedfilesChange(newValue)
              }
              renderTags={(tagValue, getTagProps) =>
                tagValue.map((option, index) => (
                  <Chip label={option.title} {...getTagProps({ index })} />
                ))
              }
            />
          </div>
          <div>
            <TextInput
              disabled={!realestateupdate}
              inputTitle={region.parameters.other.comments}
              textInput={comments}
              handleTextInputChange={handleCommentsChange}
            />
          </div>
          <div>
            <TextInput
              disabled={!realestateupdate}
              inputTitle={region.parameters.other.description}
              textInput={description}
              handleTextInputChange={handleDescriptionChange}
            />
          </div>
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              marginTop: "1rem",
              marginLeft: "auto",
              marginRight: "0.2rem",
            }}
          >
            {realestateupdate ? <Button
              style={{
                color: "#FFFFFF",
                backgroundColor: "#91C73C",
                fontWeight: "normal",
                fontWeight: "bold",
                height: "40px",
                fontSize: "0.75rem",
                padding: "5px 15px",
                marginRight: "5px",
                marginBottom: "0px",
                marginTop: "0px",
                fontFamily: '"Source Sans Pro",sans-serif',
              }}
              onClick={() => {
                handleEdit();
              }}
            >
              Enregistrer
            </Button> : <></>}
          </div>
        </GridItem>
      </GridContainer>

    </div>
  );
}

function Parameters(props) {
  const permis = JSON.parse(localStorage.getItem('permission')) || [];
  const realestateupdate = permis.includes("realestate_update");
  const [imageUrl, setImageUrl] = useState(null);
  const [imageCode, setImageCode] = useState(null);
  const [imagePreviewUrl, setImagePreviewUrl] = useState(null);

  const [localization, setLocalization] = useState(null);
  const [localizationValue, setLocalizationValue] = useState("");
  const [options, setOptions] = useState([]);
  const [validatedAddress, setValidatedAddress] = useState({});

  const [clef, setClef] = useState("");
  const [membernumber, setMembernumber] = useState("");
  const [inseecode, setInseecode] = useState("");
  const [postalcode, setPostalcode] = useState("");
  const [population, setPopulation] = useState("");
  const [territorysurface, setTerritorysurface] = useState("");
  const [brutsurface, setBrutsurface] = useState("");
  const [heatedsurface, setHeatedsurface] = useState("");
  const [floorsurface, setFloorsurface] = useState("");
  const [shonsurface, setShonsurface] = useState("");
  const [citycount, setCitycount] = useState("");
  const [sitecount, setSitecount] = useState("");
  const [buildingcount, setBuildingcount] = useState("");
  const [lightingcount, setLightingcount] = useState("");
  const [trafficlightcount, setTrafficlightcount] = useState("");
  const [othercount, setOthercount] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");

  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;

  const loaded = useRef(false);

  const handleClefChange = (event) => { setClef(event.target.value); };
  const handleMembernumberChange = (event) => { setMembernumber(event.target.value); };
  const handleInseecodeChange = (event) => { setInseecode(event.target.value); };
  const handlePostalcodeChange = (event) => { setPostalcode(event.target.value); };
  const handlePopulationChange = (event) => { setPopulation(event.target.value); };
  const handleTerritorysurfaceChange = (event) => { setTerritorysurface(event.target.value); };
  const handleBrutsurfaceChange = (event) => { setBrutsurface(event.target.value); };
  const handleHeatedsurfaceChange = (event) => { setHeatedsurface(event.target.value); };
  const handleFloorsurfaceChange = (event) => { setFloorsurface(event.target.value); };
  const handleShonsurfaceChange = (event) => { setShonsurface(event.target.value); };
  const handleCitycountChange = (event) => { setCitycount(event.target.value); };
  const handleSitecountChange = (event) => { setSitecount(event.target.value); };
  const handleBuildingcountChange = (event) => { setBuildingcount(event.target.value); };
  const handleLightingcountChange = (event) => { setLightingcount(event.target.value); };
  const handleTrafficlightcountChange = (event) => { setTrafficlightcount(event.target.value); };
  const handleOthercountChange = (event) => { setOthercount(event.target.value); };
  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };
  const handlePhoneChange = (e) => {
    setPhone(e.target.value);
  };
  useEffect(() => {
    axios
      .get(
        getSite(chartIdGroup, "parameters.parameters"),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        setClef(res.data.detail.parameters?.parameters?.clef);
        setMembernumber(res.data.detail.parameters?.parameters?.membernumber);
        setLocalization(res.data.detail.parameters?.parameters?.localization);
        setValidatedAddress(res.data.detail.parameters?.parameters?.validatedAddress)
        setInseecode(res.data.detail.parameters?.parameters?.inseecode);
        setPostalcode(res.data.detail.parameters?.parameters?.postalcode);
        setPopulation(res.data.detail.parameters?.parameters?.population);
        setTerritorysurface(res.data.detail.parameters?.parameters?.territorysurface);
        setBrutsurface(res.data.detail.parameters?.parameters?.brutsurface);
        setHeatedsurface(res.data.detail.parameters?.parameters?.heatedsurface);
        setFloorsurface(res.data.detail.parameters?.parameters?.floorsurface);
        setShonsurface(res.data.detail.parameters?.parameters?.shonsurface);
        setCitycount(res.data.detail.parameters?.parameters?.citycount);
        setSitecount(res.data.detail.parameters?.parameters?.sitecount);
        setBuildingcount(res.data.detail.parameters?.parameters?.buildingcount);
        setLightingcount(res.data.detail.parameters?.parameters?.lightingcount);
        setTrafficlightcount(res.data.detail.parameters?.parameters?.trafficlightcount);
        setOthercount(res.data.detail.parameters?.parameters?.othercount);
        setEmail(res.data.detail.parameters?.parameters?.email);
        setPhone(res.data.detail.parameters?.parameters?.phone);
        let imageCode = res.data.detail.parameters?.parameters?.imageCode;
        if (imageCode) {
          setImageCode(imageCode);
          setImagePreviewUrl(
            getProfilePicture(imageCode)
          );
        }
      })
      .catch(() => { });
  }, []);

  //Profile picture
  useEffect(() => {
    if (imageUrl) {
      const formData = new FormData();
      // we append each element to the form
      formData.append("files", imageUrl);
      axios
        .post(
          postFileUpload(chartIdGroup, "profilepic"),
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        )
        .then((res) => {
          setImageCode(res.data.files[0].url);
          setImagePreviewUrl(
            getProfilePicture(res.data.files[0].url)
          );
        })
        .catch(() => { });
    }
  }, [imageUrl]);

  const handleEdit = () => {
    axios
      .put(
        getSite(chartIdGroup, "parameters.parameters"),
        {
          imageCode,
          clef,
          membernumber,
          localization,
          validatedAddress,
          inseecode,
          postalcode,
          population,
          territorysurface,
          brutsurface,
          heatedsurface,
          floorsurface,
          shonsurface,
          citycount,
          sitecount,
          buildingcount,
          lightingcount,
          trafficlightcount,
          othercount,
          email,
          phone,
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success("Modifications enregistrées");
        }
        else {
          NotificationManager.error("Une erreur est survenue");
        }
      })
      .catch(() => {
        NotificationManager.error("Une erreur est survenue");
      });
  };

  const classes = useStyles();
  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <div>
            <div className={classes.inputImage}>
              <div className={classes.inputTitle}>
                {region.parameters.parameters.picture}
              </div>
              <ImageUpload
                disabled={!realestateupdate}
                file={imageUrl}
                setImageCode={setImageCode}
                setFile={setImageUrl}
                imagePreviewUrl={imagePreviewUrl}
                setImagePreviewUrl={setImagePreviewUrl}
              />
            </div>
          </div>
          <div>
            <TextInput
              disabled={!realestateupdate}
              inputTitle={region.parameters.parameters.key}
              textInput={clef}
              handleTextInputChange={handleClefChange}
            />
          </div>
          <div>
            <TextInput
              disabled={!realestateupdate}
              inputTitle={region.parameters.parameters.membernumber}
              textInput={membernumber}
              handleTextInputChange={handleMembernumberChange}
            />
          </div>
          <div>
            <LocalizationAutocomplete
              disabled={!realestateupdate}
              inputTitle={region.parameters.parameters.address}
              value={localization}
              setValue={setLocalization}
              inputValue={localizationValue}
              setInputValue={setLocalizationValue}
              options={options}
              setOptions={setOptions}
              setValidatedAddress={setValidatedAddress}
              validatedAddress={validatedAddress}
              loaded={loaded}
            />
          </div>
          <div>
            <TextInput
              inputTitle={region.parameters.parameters.email}
              textInput={email}
              handleTextInputChange={handleEmailChange}
              disabled={!realestateupdate}
            />
          </div>

          <div>
            <TextInput
              inputTitle={region.parameters.parameters.phone}
              textInput={phone}
              handleTextInputChange={handlePhoneChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <IntInput
              disabled={!realestateupdate}
              inputTitle={region.parameters.parameters.inseecode}
              intInput={inseecode}
              handleIntInputChange={handleInseecodeChange}
            />
          </div>
          <div>
            <IntInput
              disabled={!realestateupdate}
              inputTitle={region.parameters.parameters.postalcode}
              intInput={postalcode}
              handleIntInputChange={handlePostalcodeChange}
            />
          </div>
          <div>
            <IntInput
              disabled={!realestateupdate}
              inputTitle={region.parameters.parameters.population}
              intInput={population}
              handleIntInputChange={handlePopulationChange}
            />
          </div>
          <div>
            <IntInput
              disabled={!realestateupdate}
              inputTitle={region.parameters.parameters.territorysurface}
              intInput={territorysurface}
              handleIntInputChange={handleTerritorysurfaceChange}
            />
          </div>
          <div>
            <IntInput
              disabled={!realestateupdate}
              inputTitle={region.parameters.parameters.brutsurface}
              intInput={brutsurface}
              handleIntInputChange={handleBrutsurfaceChange}
            />
          </div>
          <div>
            <IntInput
              disabled={!realestateupdate}
              inputTitle={region.parameters.parameters.heatedsurface}
              intInput={heatedsurface}
              handleIntInputChange={handleHeatedsurfaceChange}
            />
          </div>
          <div>
            <IntInput
              disabled={!realestateupdate}
              inputTitle={region.parameters.parameters.floorsurface}
              intInput={floorsurface}
              handleIntInputChange={handleFloorsurfaceChange}
            />
          </div>
          <div>
            <IntInput
              disabled={!realestateupdate}
              inputTitle={region.parameters.parameters.shonsurface}
              intInput={shonsurface}
              handleIntInputChange={handleShonsurfaceChange}
            />
          </div>
          <div>
            <IntInput
              disabled={!realestateupdate}
              inputTitle={region.parameters.parameters.citycount}
              intInput={citycount}
              handleIntInputChange={handleCitycountChange}
            />
          </div>
          <div>
            <IntInput
              disabled={!realestateupdate}
              inputTitle={region.parameters.parameters.sitecount}
              intInput={sitecount}
              handleIntInputChange={handleSitecountChange}
            />
          </div>
          <div>
            <IntInput
              disabled={!realestateupdate}
              inputTitle={region.parameters.parameters.buildingcount}
              intInput={buildingcount}
              handleIntInputChange={handleBuildingcountChange}
            />
          </div>
          <div>
            <IntInput
              disabled={!realestateupdate}
              inputTitle={region.parameters.parameters.lightingcount}
              intInput={lightingcount}
              handleIntInputChange={handleLightingcountChange}
            />
          </div>
          <div>
            <IntInput
              disabled={!realestateupdate}
              inputTitle={region.parameters.parameters.trafficlightcount}
              intInput={trafficlightcount}
              handleIntInputChange={handleTrafficlightcountChange}
            />
          </div>
          <div>
            <IntInput
              disabled={!realestateupdate}
              inputTitle={region.parameters.parameters.othercount}
              intInput={othercount}
              handleIntInputChange={handleOthercountChange}
            />
          </div>
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              marginTop: "1rem",
              marginLeft: "auto",
              marginRight: "0.2rem",
            }}
          >
            {realestateupdate ? <Button
              style={{
                color: "#FFFFFF",
                backgroundColor: "#91C73C",
                fontWeight: "normal",
                fontWeight: "bold",
                height: "40px",
                fontSize: "0.75rem",
                padding: "5px 15px",
                marginRight: "5px",
                marginBottom: "0px",
                marginTop: "0px",
                fontFamily: '"Source Sans Pro",sans-serif',
              }}
              onClick={() => {
                handleEdit();
              }}
            >
              Enregistrer
            </Button> : <></>}
          </div>
        </GridItem>
      </GridContainer>
    </div>
  );
}

export { Ratio, Property, Other, Parameters, Occupation };
